module.exports = __webpack_public_path__ + "img/animate-1.5916d5a8.png";